import React from 'react';
import AlertNotification from '../../images/AlertNotification/AlertNotification';
import './InlineMessage.scss';
import { Spot, SpotIcon } from '../../Spot';

export interface InlineMessageProps {
  title?: string | React.JSX.Element;
  message?: string | React.JSX.Element;
  priority: 'standard' | 'medium' | 'high';
  level: 'default' | 'success' | 'warning' | 'danger';
}

export default function InlineMessage({ title, message, priority, level }: InlineMessageProps): React.JSX.Element {
  const baseClass = `spot-message spot-message--with-icon-tab spot-message--${level}`;
  return (
    <div className={baseClass}>
      <div className="message--content">
        {title && <div className="spot-message--header">{title}</div>}
        {message && <div className="spot-message--body">{message}</div>}
      </div>
      <div className="icon-tab">
        {/*<AlertNotification fill={'white'}  />*/}
        <SpotIcon
          fill={'white'}
          title={'alert-notification'}
          iconName={'alert-notification'}
          data-automation-id={'confirmationCompleteButton'}
        />
      </div>
    </div>
  );
}
